/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useCallback, useEffect } from "react";
import "../css/integration.css";
import callApi from "../utils/apiCaller";
import Swal from "sweetalert2";
import {
	Modal,
	Link,
	TextContainer,
	ResourceList,
	ResourceItem,
	TextStyle,
	Badge,
} from "@shopify/polaris";
import config from "../config/config";

import { useDispatch, useSelector } from "react-redux";
import { actFetchShowLoadingPage } from "../actions";

const UserTour = (props) => {
	const dispatch = useDispatch();
	const listAccount = useSelector((state) => state.listPayPalAccounts);
	const dataSettings = useSelector((state) => state.dataSettings);
	const [modalSubmitOpen, setModalSubmitOpen] = useState(false);
	const [listOrderDemo, setListOrderDemo] = useState([
		{
			id: 101,
			url: "customers/341",
			name: "Mae Jemison",
			location: "Decatur, USA",
		},
		{
			id: 201,
			url: "customers/256",
			name: "Ellen Ochoa",
			location: "Los Angeles, USA",
		},
	]);

	const [selectedItems, setSelectedItems] = useState([]);

	const resourceName = {
		singular: "ordersDemo",
		plural: "ordersDemo",
	};

	useEffect(() => {
		if (config.checkLocalStorage) {
			if (
				config.platform !== "WOO_COMMERCE" &&
				localStorage.getItem("paypal-remind-connect-" + config.shop) !==
					"hide" &&
				localStorage.getItem("paypal-" + config.shop + "-step") == 4
			) {
				checkConnectAccount();
			}
		}
	}, []);

	useEffect(() => {
		if (
			config.platform !== "WOO_COMMERCE" &&
			listAccount.length > 0 &&
			props.type === "step" &&
			props.openModal === true
		) {
			if (dataSettings.submit_demo === 1) {
				let listDemo = dataSettings.list_demo;
				let order = {
					id: 0,
				};
				let selected = [];
				listDemo.forEach((element) => {
					selected.push(element.id);
				});
				listDemo.push(order);
				listDemo.reverse();
				setListOrderDemo(listDemo);
				setSelectedItems(selected);

				setModalSubmitOpen(true);
			}
		}
	}, [props]);

	const closeModalSubmit = () => {
		setModalSubmitOpen(false);
		props.changeStatusModal(false);
	};

	const submitDemoOrder = () => {
		let params = {
			action: "submitDemoOrder",
			listId: JSON.stringify(selectedItems),
		};
		dispatch(actFetchShowLoadingPage(true));
		setModalSubmitOpen(false);
		callApi("get", params).then(async (res) => {
			if (res.data.state === 1) {
				let listDemo = res.data.listOrders;
				let order = {
					id: 0,
				};
				let selected = [];
				listDemo.forEach((element) => {
					selected.push(element.id);
				});
				listDemo.push(order);
				listDemo.reverse();
				setListOrderDemo(listDemo);
				setSelectedItems(selected);
				setModalSubmitOpen(true);
				dispatch(actFetchShowLoadingPage(false));
				props.changeStatusModal(false);
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: "Orders has been successfully synchronized!",
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				});
			}
		});
	};

	const checkConnectAccount = () => {
		let params = {
			action: "checkConnectAccount",
		};
		callApi("get", params).then(async (res) => {
			if (res.data.state === 0) {
				Swal.fire({
					icon: "warning",
					title: "PayPal account is not connected",
					text: "Sync tracking information to PayPal only after you connect your PayPal account",
					confirmButtonText:
						'<svg id="CWPP_SVG_PPTM" class="PPTM" xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="18px" viewBox="0 0 18 18" focusable="false"><path id="Fill-8" class="PPTM-btm" fill="#009cde" d="M13.6023044,4.67342223 C13.8196336,3.28812419 13.6008532,2.34542498 12.8514484,1.49160831 C12.0263956,0.551629995 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.43245482 2.3109822,0.817370681 L0.00598653054,15.4327457 C-0.0395473836,15.7211605 0.183405526,15.9818221 0.475294243,15.9818221 L3.89269613,15.9818221 L3.65686311,17.4774071 C3.61713431,17.7297247 3.81196867,17.957917 4.06739398,17.957917 L6.94782221,17.957917 C7.28887304,17.957917 7.57912907,17.7097715 7.63228221,17.3731061 L7.66058217,17.226722 L8.20317953,13.7860604 L8.23819166,13.5959605 C8.29134479,13.2591138 8.58160082,13.0111496 8.92247024,13.0111496 L9.35331903,13.0111496 C12.1439493,13.0111496 14.329033,11.8774436 14.9674148,8.59894727 C15.2342689,7.22906764 15.0963973,6.08556642 14.3908938,5.28163282 C14.1773742,5.03856625 13.9119713,4.83740146 13.6023044,4.67342223"></path><path id="Fill-9" class="PPTM-top" fill="#012169" d="M13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L4.75112833,10.5399219 L4.72446105,10.7106288 C4.78523341,10.3256767 5.11431118,10.0419515 5.50397989,10.0419515 L7.12832518,10.0419515 C10.3182389,10.0419515 12.815892,8.7459583 13.5457045,4.99802736 C13.5672923,4.88718584 13.5857961,4.7796097 13.6023044,4.67384766" style="fill-opacity: 0.7;"></path><path id="Fill-10" class="PPTM-top" fill="#003087" d="M5.67323544,4.69235148 C5.70988026,4.46069089 5.85845507,4.27111742 6.05855031,4.17515152 C6.14961814,4.13161312 6.25120775,4.10730418 6.35769543,4.10730418 L10.6968416,4.10730418 C11.2109576,4.10730418 11.6902429,4.14104644 12.128348,4.21161494 C12.2537024,4.23175145 12.3754285,4.25497193 12.4938892,4.28127638 C12.6121686,4.30739943 12.7271825,4.33678785 12.8383869,4.36944165 C12.8940797,4.38558714 12.9486841,4.40263969 13.0025629,4.42059928 C13.2177152,4.49189341 13.4179919,4.57624907 13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L5.67323544,4.69235148"></path></svg> Connect Now ',
					confirmButtonColor: "#0070ba",
					showCancelButton: true,
					showCloseButton: true,
					allowOutsideClick: false,
					customClass: {
						confirmButton: "connect-to-paypal",
					},
					footer: "<a target='_blank' href='https://www.youtube.com/watch?v=939S7HqgJi4&feature=emb_title'>How to connect PayPal account?</a>",
				}).then((result) => {
					if (result.isConfirmed) {
						props.connectPayPal();
					}
					if (config.checkLocalStorage) {
						localStorage.setItem(
							"paypal-remind-connect-" + config.shop,
							"hide"
						);
					}
				});
			}
		});
	};

	function renderItem(item) {
		const { id } = item;
		if (id == 0) {
			return (
				<li className="Polaris-ResourceItem__ListItem">
					<div className="Polaris-ResourceItem__ItemWrapper">
						<div className="Polaris-ResourceItem Polaris-ResourceItem--selectable">
							<button className="Polaris-ResourceItem__Button"></button>
							<div
								className="Polaris-ResourceItem__Container"
								id="0"
							>
								<div className="Polaris-ResourceItem__Owned Polaris-ResourceItem__OwnedNoMedia">
									<div className="Polaris-ResourceItem__Handle"></div>
								</div>
								<div
									className="Polaris-ResourceItem__Content"
									style={{ width: "100%", display: "flex" }}
								>
									<div
										className="vertical-center"
										style={{ width: "10%" }}
									>
										<TextStyle variation="strong">
											<p className="text-truncate font-weight-bold text-left">
												Order
											</p>
										</TextStyle>
									</div>
									<div
										className="vertical-center"
										style={{ width: "20%" }}
									>
										<TextStyle variation="strong">
											<p className="text-truncate font-weight-bold text-left">
												Tracking Number
											</p>
										</TextStyle>
									</div>
									<div
										className="vertical-center"
										style={{ width: "20%" }}
									>
										<TextStyle variation="strong">
											<p className="text-truncate font-weight-bold text-center">
												Carrier
											</p>
										</TextStyle>
									</div>{" "}
									<div
										className="vertical-center"
										style={{ width: "20%" }}
									>
										<TextStyle variation="strong">
											<p className="text-truncate font-weight-bold text-center">
												Transaction id
											</p>
										</TextStyle>
									</div>
									<div
										className="vertical-center"
										style={{ width: "20%" }}
									>
										<TextStyle variation="strong">
											<p className="text-truncate font-weight-bold text-center">
												Status
											</p>
										</TextStyle>
									</div>
									<div
										className="vertical-center"
										style={{ width: "20%" }}
									></div>
								</div>
							</div>
						</div>
					</div>
				</li>
			);
		} else {
			return (
				<ResourceItem id={id}>
					<div style={{ width: "100%", display: "flex" }}>
						<div
							className="vertical-center"
							style={{ width: "10%" }}
						>
							<TextStyle>
								<p className="text-truncate  text-left">
									<Link
										external
										url={
											"https://" +
											config.shop +
											"/admin/orders/" +
											item.order_id
										}
									>
										{item.name}
									</Link>
								</p>
							</TextStyle>
						</div>
						<div
							className="vertical-center"
							style={{ width: "20%" }}
						>
							<TextStyle>
								<p className="text-truncate   text-left">
									{item.tracking_number}
								</p>
							</TextStyle>
						</div>
						<div
							className="vertical-center"
							style={{ width: "20%" }}
						>
							<TextStyle>
								<p className="text-truncate  text-center">
									{item.tracking_company}
								</p>
							</TextStyle>
						</div>{" "}
						<div
							className="vertical-center"
							style={{ width: "20%" }}
						>
							<TextStyle>
								<p className="text-truncate  text-center">
									{item.transaction_id}
								</p>
							</TextStyle>
						</div>
						<div
							className="vertical-center"
							style={{ width: "20%" }}
						>
							<TextStyle>
								<p className="text-truncate text-center">
									{item.add_tracking_status === "1" ? (
										<Badge
											status="success"
											progress="complete"
										>
											Completed
										</Badge>
									) : (
										<span>
											{item.add_tracking_status ===
											"3" ? (
												<Badge status="warning">
													No Transaction Id
												</Badge>
											) : (
												"---"
											)}
										</span>
									)}
								</p>
							</TextStyle>
						</div>
						{item.add_tracking_status === "1" ? (
							<div
								className="vertical-center"
								style={{ width: "20%" }}
							>
								<TextStyle>
									<Link
										url={
											"https://www.paypal.com/activity/payment/" +
											item.transaction_id
										}
										external
									>
										Check on PayPal
									</Link>
								</TextStyle>
							</div>
						) : (
							<div
								className="vertical-center"
								style={{ width: "20%" }}
							></div>
						)}
					</div>
				</ResourceItem>
			);
		}
	}

	return (
		<div>
			<Modal
				large={true}
				open={modalSubmitOpen}
				onClose={() => closeModalSubmit()}
				title="Test syncing function with some old orders"
				primaryAction={{
					disabled: selectedItems.length == 0 ? true : false,
					content: "Sync now",
					onAction: () => submitDemoOrder(),
				}}
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => closeModalSubmit(),
					},
				]}
			>
				<Modal.Section>
					<TextContainer>
						<p>
							Select the orders that you want to sync to PayPal:
						</p>
						<ResourceList
							resourceName={resourceName}
							items={listOrderDemo}
							renderItem={renderItem}
							selectedItems={selectedItems}
							onSelectionChange={setSelectedItems}
							selectable
						/>
					</TextContainer>
				</Modal.Section>
			</Modal>
		</div>
	);
};

export default UserTour;
